import * as yup from 'yup'
import { defineMessages } from 'react-intl'

import { sanitizeNumber } from 'utils/masks'

const PLAN_ID_LENGTH = 36

const nameMessages = defineMessages({
  required: {
    id: 'spanish.plan.form.name.required',
    defaultMessage: 'El nombre es requerido'
  },
  max: {
    id: 'spanish.plan.form.name.max',
    defaultMessage: 'El nombre no puede contener más de 50 caracteres'
  }
})
const sellingPriceMessages = defineMessages({
  required: {
    id: 'spanish.plan.form.sellingPrice.required',
    defaultMessage: 'El precio es requerido'
  }
})
const photoMessages = defineMessages({
  required: {
    id: 'spanish.plan.form.photo.required',
    defaultMessage: 'La foto es requerida'
  }
})
const planIdMessages = defineMessages({
  required: {
    id: 'spanish.plan.form.planId.required',
    defaultMessage: 'El ID es requerido'
  },
  min: {
    id: 'spanish.plan.form.planId.min',
    defaultMessage: 'Se necesitan 36 caracteres'
  }
})
export const schema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    name: yup
      .string()
      .required(intl.formatMessage(nameMessages.required))
      .max(50, intl.formatMessage(nameMessages.max)),
    photo: yup.string().required(intl.formatMessage(photoMessages.required)),
    sellingPrice: yup.string().required(intl.formatMessage(sellingPriceMessages.required)),
    planId: yup
      .string()
      .test('min-plan-id-number', intl.formatMessage(planIdMessages.min), (planId = ''): TSFixMe => {
        return sanitizeNumber(planId, '_').length === PLAN_ID_LENGTH
      })
      .required(intl.formatMessage(planIdMessages.required))
  })
}
